const SkeletonLoader = ({ rows = 30, cols = 9 }) => {
  return Array.from({ length: rows }).map((_, rowIndex) => (
    <tr key={rowIndex} className="border-b">
      {Array.from({ length: cols }).map((_, colIndex) => (
        <td key={colIndex} className="px-4 py-4">
          <div className="w-full h-4 bg-gray-300 rounded animate-pulse"></div>
        </td>
      ))}
    </tr>
  ));
};
export default SkeletonLoader;

